import React from 'react'
import { connect } from 'react-redux'
import { Button, Text, Input, LinkCopiable } from 'components/base'
import { actions as OrganizationsActions } from 'data/organizations'
import { selectors as ConfigSelectors } from 'data/config'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import { InfoIcon } from 'components/Utils/Icons'

class OpenID extends React.Component {
  state = {
    displayForm: false,
    name: '',
    url: '',
    clientId: '',
    clientSecret: '',
  }
  render() {
    const openIdCallbackURL = `https://${
      this.props.appDomain
    }/api/auth/openid/callback`
    if (!this.state.displayForm) {
      return (
        <div className="margin-top-large">
          <Text.Subtitle className="margin-bottom-normal">
            OpenID authentication
          </Text.Subtitle>
          <div className="margin-bottom-medium flexbox shade-10 font-size-large line-height-larger">
            Choose a custom OpenID compatible authentication provider, such as
            Okta, Auth0, Azure AD.
          </div>

          <Button.Primary
            onClick={() => {
              this.setState({ displayForm: true })
            }}
          >
            Configure OpenID authentication
          </Button.Primary>
        </div>
      )
    }
    return (
      <div className="margin-top-large">
        <Text.Subtitle>Set up</Text.Subtitle>
        <div className="shade-20 margin-top-medium line-height-larger font-size-large">
          <Text.ExternalLink
            className="font-size-large"
            target="_blank"
            rel="noopener noreferrer"
            href="https://slite-docs.slite.com/p/channel/5fDpAEUPsXGCsYTZovPRjq"
          >
            Follow our guide
          </Text.ExternalLink>{' '}
          for setting up custom authentication. When you are asked to provide a
          redirect or callback URL, please use the following:
          <div className="margin-top-medium flexbox" style={{ height: 50 }}>
            <code
              style={{
                borderRadius: '4px 0px 0px 4px',
              }}
              className="background-shade-50 radius-normal padding-small flexbox flexbox-align-center"
            >
              {openIdCallbackURL}
            </code>
            <LinkCopiable
              style={{
                borderRadius: '0 4px 4px 0',
              }}
              link={openIdCallbackURL}
            >
              <div>Copy link</div>
            </LinkCopiable>
          </div>
        </div>

        <div className="flexbox flexbox-align-center margin-top-large margin-bottom-medium">
          <div className="width-full margin-right-large">
            <div className="flexbox flexbox-align-center">
              <Text.Name className="margin-bottom-smaller shade-05">
                Provider name
              </Text.Name>
              <TooltipOnHover
                tooltipContent="This is displayed on your login page."
                placement="right"
              >
                <InfoIcon size={16} className="margin-left-small shade-30" />
              </TooltipOnHover>
            </div>
            <Input
              value={this.state.name}
              onChange={e => this.setState({ name: e.target.value })}
            />
          </div>
          <div className="width-full">
            <Text.Name className="margin-bottom-smaller shade-05">
              Provider URL
            </Text.Name>
            <Input
              value={this.state.url}
              onChange={e => this.setState({ url: e.target.value })}
            />
          </div>
        </div>
        <div className="flexbox flexbox-align-center">
          <div className="width-full margin-right-large">
            <Text.Name className="margin-bottom-smaller shade-05">
              Client ID
            </Text.Name>
            <Input
              value={this.state.clientId}
              onChange={e => this.setState({ clientId: e.target.value })}
              autoComplete="off"
            />
          </div>
          <div className="width-full">
            <Text.Name className="margin-bottom-smaller shade-05">
              Client secret
            </Text.Name>
            <Input
              type={'password'}
              value={this.state.clientSecret}
              autocomplete="new-password" //off doesn't work on chrome
              onChange={e => this.setState({ clientSecret: e.target.value })}
            />
          </div>
        </div>
        <Button.Primary
          className="margin-top-normal"
          onClick={() => {
            const { displayForm, ...input } = this.state
            this.props.setOrganizationAuthProvider({ input })
          }}
        >
          Validate and save
        </Button.Primary>
      </div>
    )
  }
}

export default connect(
  state => ({
    appDomain: ConfigSelectors.getAppDomain(state),
  }),
  {
    setOrganizationAuthProvider:
      OrganizationsActions.setOrganizationAuthProvider,
  }
)(OpenID)
